import React from 'react'
import './Spinner.scss'

export interface SpinnerProps {
  size?: 'sm'
  label?: string
}

export const Spinner: React.FC<SpinnerProps> = ({ size, label }) => {
  const variant = size ? `spinner-${size}` : 'spinner'
  return (
    <div className={variant} role='status'>
      {label ? <span className='visually-hidden'>{label}</span> : null}
    </div>
  )
}
